import { Typography } from '@mui/joy';
import { styled } from '@mui/joy/styles';
import { useTranslation } from 'next-i18next';

const ExpiredInvitation = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <Content>
        <Typography level="h2">{t('expiredInvitation.description_1')}</Typography>
        <Typography level="body-md" fontWeight="bold">
          {t('expiredInvitation.description_2')}
        </Typography>
        <Typography level="body-md">{t('expiredInvitation.description_3')}</Typography>
        <Typography level="body-md">{t('expiredInvitation.description_4')}</Typography>
      </Content>
    </Container>
  );
};

const Container = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '32px 16px',
}));

const Content = styled('div')(() => ({
  maxWidth: '600px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

export default ExpiredInvitation;
